import { SolarProduct } from "../solar-product/solar-product";

export class ProviderDashboardData {
	companyName: string;
	totalNumberOfActiveSolarProducts: number;
	totalNumberOfInactiveSolarProducts: number;
	totalNumberOfSaleRequests: number;
	totalNumberOfInstalations: number;
	accountBalance: number;

	constructor({
		companyName,
		totalNumberOfActiveSolarProducts,
		totalNumberOfInactiveSolarProducts,
		totalNumberOfSaleRequests,
		totalNumberOfInstalations,
		accountBalance,
	}: ProviderDashboardData) {
		this.companyName = companyName;
		this.totalNumberOfActiveSolarProducts = totalNumberOfActiveSolarProducts;
		this.totalNumberOfInactiveSolarProducts = totalNumberOfInactiveSolarProducts;
		this.totalNumberOfSaleRequests = totalNumberOfSaleRequests;
		this.totalNumberOfInstalations = totalNumberOfInstalations;
		this.accountBalance = accountBalance;
	}
}

export interface User {
	guid: string;
	username: string;
	userType: string;
	created: string;
	lastLogin: string;
	phoneNumber: string;
}

export interface SolarProviderModel {
	firstName: string;
	lastName: string;
	type: string;
	status: string;
	userId: number;
	user: User;
	solarProviderCompany: SolarProviderCompany;
}

export interface GridSolarProviderModel {
	id: string;
	businessName: string;
	contactEmail: string;
	contactPhone: string;
	numberOfSolarProducts: number;
	status: GridSolarProviderStatuses;

	email: string;
	phoneNumber: string;
	companyStatus: string;
}

export type GridSolarProviderStatuses = "Active" | "Suspended" | "Pending";

interface SolarProviderCompany {
	id: string;
	name: string;
	businessInfo: string | null;
	businessType: string;
	rcNumber: string;
	address: string;
	state: string;
	city: string;
	firstLogin: boolean;
	solarProducts: SolarProduct[];
	numberOfSolarProducts: number;
}

export interface SolarProviderInfoQuery {
	companyId?: string;
	start?: Date;
	end?: Date;
	SolarProviderId?: string;
	page?: number;
	pageSize?: number;
}

export interface ProviderBusinessInfo {
	businessName: string;
	isSuspended: boolean;
	status: ProviderBusinessInfoStatus;
	address: string;
	dateCreated: string;
	phoneNumber: string;
	email: string;
	contactPerson: string;
	ordersCompleted: number;
	ordersInProgress: number;
	numberOfSolarProducts: number;
	revenue: number;

	id: string;
	name: string;
	businessInfo: string;
	businessType: string;
	rcNumber: string;
	state: string;
	city: string;
	firstLogin: boolean;
}

export enum ProviderBusinessInfoStatus {
	ACTIVE = "Active",
	SUSPENDED = "Suspended",
	PENDING = "Pending",
}

export interface SolarProviderCustomerQuery {
	page: number;
	pageSize: number;
	paymentDate?: Date;
	search?: string;
	status?: string;
}
